module.exports = __webpack_public_path__ + "img/box1.718c73f1.png";